"use client";

import {
    ExclamationTriangleIcon,
    ArrowPathIcon,
} from "@heroicons/react/24/outline";
import { useRouter } from "next/navigation";

interface ErrorFallbackProps {
    title?: string;
    message?: string;
    showRefresh?: boolean;
}

const ErrorFallback = ({
                           title = "مشکلی پیش آمده",
                           message = "متأسفانه در دریافت اطلاعات خطایی رخ داده است. لطفاً چند لحظه دیگر دوباره تلاش کنید.",
                           showRefresh = true,
                       }: ErrorFallbackProps) => {

    const router = useRouter();

    return (
        <div className="flex h-full items-center justify-center">
            <div
                className="relative w-full max-w-md overflow-hidden rounded-3xl border border-red-100 bg-white p-8 shadow-xl">
                {/* Background Glow */}
                <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-red-100 blur-3xl opacity-70"/>
                <div className="absolute -left-10 -top-10 h-32 w-32 rounded-full bg-red-100 blur-3xl opacity-70"/>

                {/* Icon */}
                <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
                    <ExclamationTriangleIcon className="h-10 w-10 text-danger"/>
                </div>

                {/* Title */}
                <h2 className="relative mt-6 text-center text-2xl font-bold text-gray-900">
                    {title}
                </h2>

                {/* Message */}
                <p className="relative mt-3 text-center leading-7 text-gray-500">
                    {message}
                </p>

                {/* Refresh Button */}
                {showRefresh && (
                    <button
                        onClick={() => router.refresh()}
                        className="relative mt-8 flex w-full items-center justify-center gap-2 rounded-xl bg-red-500 px-4 py-3 font-medium text-white transition-all duration-200 hover:bg-red-600 active:scale-[0.98]"
                    >
                        <ArrowPathIcon className="h-5 w-5"/>
                        تلاش مجدد
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErrorFallback;